export default "__VITE_ASSET__O6oKEiT2__"